export const STEEPING_DISPLAY_NAMES = [
    {
        referenceName: 'wet_1st_hours',
        displayName: '1st wet',
    },
    {
        referenceName: 'dry_1st_hours',
        displayName: '1st dry',
    },
    {
        referenceName: 'wet_2nd_hours',
        displayName: '2nd wet',
    },
    {
        referenceName: 'dry_2nd_hours',
        displayName: '2nd dry',
    },
];
export const GERMINATION_DISPLAY_NAMES = [
    {
        referenceName: 'day_1_temperature',
        displayName: '1st day/°C',
    },
    {
        referenceName: 'day_2_temperature',
        displayName: '2nd day/°C',
    },
    {
        referenceName: 'day_3_temperature',
        displayName: '3rd day/°C',
    },
    {
        referenceName: 'day_4_temperature',
        displayName: '4th day/°C',
    },
    {
        referenceName: 'day_5_temperature',
        displayName: '5th day/°C',
    },
    {
        referenceName: 'dq_total',
        displayName: 'dq total',
    },
    {
        referenceName: 'co2_total',
        displayName: 'CO2 total',
    },
    {
        referenceName: 'day_1_temperature_factual_before',
        displayName: '1st day/°C before vessel',
    },
    {
        referenceName: 'day_1_temperature_factual_after',
        displayName: '1st day/°C  after vessel',
    },
    {
        referenceName: 'day_2_temperature_factual_before',
        displayName: '2nd day/°C before vessel',
    },
    {
        referenceName: 'day_2_temperature_factual_after',
        displayName: '2nd day/°C after vessel',
    },
    {
        referenceName: 'day_3_temperature_factual_before',
        displayName: '3rd day/°C before vessel',
    },
    {
        referenceName: 'day_3_temperature_factual_after',
        displayName: '3rd day/°C after vessel',
    },
    {
        referenceName: 'moisture_manual_24h',
        displayName: '24h Moisture, manual',
    },
    {
        referenceName: 'moisture_manual_48h',
        displayName: '48h Moisture, manual',
    },
    {
        referenceName: 'moisture_manual_72h',
        displayName: '72h Moisture, manual',
    },
    {
        referenceName: 'moisture_start',
        displayName: 'Kiln start moisture',
    },
];

export const RECIPE_VALUES = [
    {
        referenceName: 'day_1_temperature',
        displayName: '1st day/°C',
    },
    {
        referenceName: 'day_2_temperature',
        displayName: '2nd day/°C',
    },
    {
        referenceName: 'day_3_temperature',
        displayName: '3rd day/°C',
    },
    {
        referenceName: 'day_4_temperature',
        displayName: '4th day/°C',
    },
    {
        referenceName: 'day_5_temperature',
        displayName: '5th day/°C',
    }
]

export const MEASURED_TEMPERATURES = [
    {
        referenceName: 'day_1_temperature_factual_before',
        displayName: '1st day/°C before vessel',
    },
    {
        referenceName: 'day_1_temperature_factual_after',
        displayName: '1st day/°C  after vessel',
    },
    {
        referenceName: 'day_2_temperature_factual_before',
        displayName: '2nd day/°C before vessel',
    },
    {
        referenceName: 'day_2_temperature_factual_after',
        displayName: '2nd day/°C after vessel',
    },
    {
        referenceName: 'day_3_temperature_factual_before',
        displayName: '3rd day/°C before vessel',
    },
    {
        referenceName: 'day_3_temperature_factual_after',
        displayName: '3rd day/°C after vessel',
    }
]

export const MEASURED_MOISTURES = [
    {
        referenceName: 'moisture_manual_24h',
        displayName: '24h Moisture, manual',
    },
    {
        referenceName: 'moisture_manual_48h',
        displayName: '48h Moisture, manual',
    },
    {
        referenceName: 'moisture_manual_72h',
        displayName: '72h Moisture, manual',
    },
    {
        referenceName: 'moisture_start',
        displayName: 'Kiln start moisture',
    }
]